"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderMobile = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./HeaderMobile.css"));
var _icons = require("@cian/ui-kit-design-tokens/icons");
var _uiKit = require("@cian/ui-kit");
var _SliderModal = require("../../../SliderModal");
var _tracking = require("./tracking");
var _useHelpModal = require("./hooks/useHelpModal");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HeaderMobile = props => {
  const {
    offerId,
    onClose,
    title,
    subtitle,
    help
  } = props;
  const {
    isHelpModalVisible,
    openHelpModal,
    closeHelpModal
  } = (0, _useHelpModal.useHelpModal)(offerId);
  return /*#__PURE__*/React.createElement("div", {
    className: style['header']
  }, /*#__PURE__*/React.createElement(_uiKit.IconButton, {
    icon: /*#__PURE__*/React.createElement(_icons.IconActionArrowLeft24, {
      color: "icon-main-default"
    }),
    onClick: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: style['heading']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, title), /*#__PURE__*/React.createElement(_uiKit.UIText3, {
    color: "text-secondary-default"
  }, subtitle)), !!help && /*#__PURE__*/React.createElement("div", {
    className: style['help']
  }, /*#__PURE__*/React.createElement(_icons.IconActionHelp24, {
    color: "icon-main-default",
    onClick: openHelpModal
  }), isHelpModalVisible && /*#__PURE__*/React.createElement(_SliderModal.SliderModal, {
    slides: help,
    onClose: closeHelpModal,
    onScrollNext: _tracking.trackNextHelpSlideShow
  })));
};
exports.HeaderMobile = HeaderMobile;